const devicePaths = {
  SEARCH_DEVICE: "search",
  DEVICE_ID: (id) => id,
  DEVICE_TRACKING: "app-version",
  SYNC_SEARCH: "sync/search"
};

export default devicePaths;
